<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="id"
      :col="6"
      :itemNames="['search_locationName','create_button']"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_locationName" label="位置名称" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-input v-model="queryParams.locationName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
      </a-form-item>
      <template #operation>
        <a-button type="primary" style="margin-bottom: 20px" @click="addOrEdit()">新建</a-button>
      </template>
      <template slot="action" slot-scope="rowItem">
        <a @click="addOrEdit(rowItem.record)">编辑</a>
        <template v-if="rowItem.record.locationType!==1">
          <a-divider type="vertical"/>
          <a-popconfirm title="是否要删除本条数据？" @confirm="deleteEvent(rowItem.record)">
            <a>删除</a>
          </a-popconfirm>
        </template>
      </template>
    </search-page-view>
  </a-card>
</template>
<script>
export default {
  name: 'DiscoveryManageList',
  data() {
    return {
      queryParams: {
        locationName: ''
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'DiscoveryManageList', title: '位置发现管理' }
    ])
  },
  methods: {
    addOrEdit(record) {
      let params = {
        serverUniqueId: this.$route.query.serverUniqueId,
        serverId: this.$route.query.serverId
      }
      if (record && record.id) {
        params.type = record.locationType
        params.id = record.id
      }
      this.openNewPage('LocalDiscoveryAddOrEdit', params)
    },
    deleteEvent(record) {
      let params = {
        id: record.id
      }
      this.getHttpServices().getUserService().post('api/location/discovery/del', params)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getUserService().post('api/location/discovery/listPage', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '位置名称',
          dataIndex: 'locationName'
        },
        {
          title: '类型',
          dataIndex: 'locationTypeStr'
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: 120,
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">


</style>